import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface EvidenceData {
  source_refs?: string[];
  data_ids?: Record<string, any>;
}

interface EvidenceTooltipProps {
  evidence?: EvidenceData;
  children?: React.ReactNode;
}

const SOURCE_LABELS: Record<string, string> = {
  matrix_weighted_scores: "Gewichtete Matrix-Scores",
  best_option_calculation: "Deterministische Score-Berechnung",
  decision_steps: "Phase 1 Analyse-Antworten",
  scenarios: "Strategische Optionen (Phase 2)",
  decision_matrix_entries: "Bewertungsmatrix (Phase 3)",
  tie_resolution: "Tie-Breaking Logik",
  user_context: "Nutzer-Kontext aus Onboarding",
  decision_steps_by_user: "Team-Antworten nach Person",
};

export const EvidenceTooltip = ({ evidence, children }: EvidenceTooltipProps) => {
  if (!evidence?.source_refs || evidence.source_refs.length === 0) return <>{children}</>;

  const dataIdCount = evidence.data_ids
    ? Object.values(evidence.data_ids).reduce((sum: number, v) => {
        if (Array.isArray(v)) return sum + v.length;
        if (v && typeof v === "object") return sum + Object.keys(v).length;
        return sum + (v ? 1 : 0);
      }, 0)
    : 0;

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center gap-1 cursor-help">
            {children}
            <Info className="h-3 w-3 text-muted-foreground/50 shrink-0" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs">
          <div className="space-y-1.5">
            <p className="text-xs font-medium">Datenquellen</p>
            <ul className="text-xs text-muted-foreground space-y-0.5">
              {evidence.source_refs.map((ref) => (
                <li key={ref} className="flex items-center gap-1">
                  <span className="text-muted-foreground/60">•</span>
                  {SOURCE_LABELS[ref] || ref}
                </li>
              ))}
            </ul>
            {dataIdCount > 0 && (
              <p className="text-[10px] text-muted-foreground/70 pt-1 border-t border-border/50">
                {dataIdCount} Datenpunkt{dataIdCount !== 1 ? "e" : ""} referenziert
              </p>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
